import { OverlayService } from './../../../services/overlay.service';
import { BbSelectOption } from './../../shared/bb-select/bb-select.component';
import { Project } from './../../../interfaces/project';
import { Component, Input, ViewChild, TemplateRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { isArray } from 'util';
import { ModalDefinition } from '../../../services/overlay.service';
import { CustomFieldsService } from '../../../services/custom-fields.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'library-project-details-metadata',
	templateUrl: './library-project-details-metadata.component.html',
	styleUrls: ['./library-project-details-metadata.component.scss']
})

export class LibraryProjectDetailsMetadataComponent implements OnInit, OnChanges {

	@Input() project: Project;
	@Input() form: NgForm;

	@ViewChild('qrcodeModal') qrcodeModal: TemplateRef<any>;

	justAddedIndex: number;
	tags: string;
	startClipOptions: BbSelectOption[];
	qrCodeImgUrl = '';
	customFields: any[] = [];

	constructor(
		private customFieldsService: CustomFieldsService,
		private overlayService: OverlayService,
		private translate: TranslateService
	) {
	}

	ngOnInit() {
		if (this.project && (!this.project.cat || !Array.isArray(this.project.cat))) {
			this.project.cat = [];
		}
		this.startClipOptions = [{
			label: 'Test',
			value: 'test'
		}];
		if (this.project && this.project.cat && this.project.cat.join) {
			this.tags = this.project.cat.join(',');
		} else {
			this.tags = [] as any;
		}
		this.customFields = this.customFieldsService.getCustomFields('project');
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (typeof simpleChanges.project !== 'undefined' && !simpleChanges.project.firstChange) {
			if (this.project && this.project.cat && this.project.cat.join) {
				this.tags = this.project.cat.join(',');
			} else {
				this.tags = [] as any;
			}
		}
	}

	datepickerClicked(event: MouseEvent) {
		event.stopPropagation();
	}

	onContextOptionsChange() {
		if (this.project?.contexts?.some((item) => !item.code || !item.label)) {
			this.form.controls.contexts.setErrors(['Values can not be empty']);
		}
	}

	showQRCode() {
		const modal: ModalDefinition = {
			icon: 'qrcode',
			title: (this.project.title ? this.project.title + ' - ' + this.translate.instant('QR_CODE') : this.translate.instant('QR_CODE')),
			component: {
				name: 'custom-content',
				templateRef: this.qrcodeModal
			}
		};

		this.overlayService.createModal(modal);
	}
}
